import Share from "../Share/Share"
import Post from "../post/post"
import "./feed.css"
import { useEffect,useState,useContext } from "react";
import axios from "axios"
import {AuthContext} from "../../context/AuthContext";

export default function Feed({username}) {
    const[posts,setPosts] = useState([]);
    const {user} = useContext(AuthContext);

    useEffect(() =>{
        const fetchPosts = async () =>{
            const res = username ? await axios.get("https://connect-o.herokuapp.com/api/posts/profile/"+username) : await axios.get("https://connect-o.herokuapp.com/api/posts/");
            // const res = await axios.get("posts/timeline/6102f6609b9a8480dc5b186f");
            setPosts(
                res.data.sort((p1,p2)=>{
                    return new Date(p2.createdAt) - new Date(p1.createdAt);
                })
            );
            // console.log(res.data);
        }    
        fetchPosts();
    },[username,user._id])


    return (
        <div className="feed">
            <div className="feedWrapper">
                {(!username || username === user.username) && <Share/>}
                {
                    posts.map((p)=>(
                       <Post key={p._id} post={p} />
                    ))
                }
            </div>
        </div>
    )
}
